// Turn an axios error into a readable message.
//
// FastAPI returns validation failures (HTTP 422) as `detail: [{ loc, msg, type }]`,
// so a naive `error.response.data.detail` renders as "[object Object]". This
// helper flattens that array into "field: message" lines and falls back to the
// plain string detail or the axios message for everything else.
export function apiErrorMessage(error, fallback = 'Something went wrong') {
  const detail = error?.response?.data?.detail;

  if (Array.isArray(detail)) {
    const parts = detail.map(item => {
      if (typeof item === 'string') return item;
      const field = Array.isArray(item?.loc)
        ? item.loc.filter(p => p !== 'body').join('.')
        : '';
      const msg = item?.msg || 'invalid value';
      return field ? `${field}: ${msg}` : msg;
    });
    if (parts.length) return parts.join('; ');
  }

  if (typeof detail === 'string' && detail) return detail;
  if (!error?.response) return 'Network error — backend unreachable';
  return error?.message || fallback;
}
